// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"91a5d727","359":"0a5352a5","977":"cd2553e4"}[chunkId] + ".chunk.js";
};